<div *ngFor="let destination of destinations; let i = index;">
  <div class="flex-row">
    <a  class="address-header" data-toggle="collapse" href="#address-collapse-{{i}}" aria-expanded="true"
    >Адрес {{ i + 1}} </a>
    <i class="material-icons">keyboard_arrow_down</i>
  </div>
  <div class="collapse-body collapse in" id="address-collapse-{{i}}">
    <div class="flex-centered flex-end delete-row">
      <span (click)="onDelete(i)">Удалить</span>
    </div>
    <div class="flex-centered flex-space-between form-group">
      <address-field class="address-field" [point]="destination.destination" (onChange)="destination.destination = $event"
                     (onFocus)="onFocusAddr($event)" [context]="geoContext"></address-field>
      <input type="number" class="text-input floor-input" name="floor" [(ngModel)]="destination.floor" placeholder="Этаж">
    </div>
    <div class="form-group storehouses" *ngIf="storehouses.length > 0">
        <span class="storehouse" *ngFor="let storehouse of storehouses; let si = index;" (click)="onClickStorehouse(storehouse, i)">
          {{ storehouse.city.name }}, {{ storehouse.address }}<span *ngIf="si < storehouses.length - 1">, </span>
        </span>
    </div>
    <div class="form-group">
      <label>Прибытие</label>
      <order-panel-datepicker
              class="date-time"
              [(value)]="arrivalTimes[i]"
              [datepicker]="arrivalDatePickerOptions"
              [timepicker]="arrivalTimePickerOptions"
              [isValid]="arrivalTimeValid[i]"
              name="arrivalTime"
              ngDefaultControl
      ></order-panel-datepicker>
    </div>
    <div class="form-group" [class.has-error]="!arrivalTimeValid[i]">
      <label>Максимальное время прибытия</label>
      <order-panel-datepicker
              class="date-time"
              [(value)]="arrivalTimeEnds[i]"
              [datepicker]="arrivalDatePickerOptions"
              [timepicker]="arrivalTimePickerOptions"
              [isValid]="arrivalTimeValid[i]"
              name="arrivalTimeEnd"
              ngDefaultControl
      ></order-panel-datepicker>
      <span class="help-block" *ngIf="!arrivalTimeValid[i]">Максимальное время должно быть больше времени прибытия</span>
    </div>
    <div class="form-group">
      <span class="destination-options" title="Показать/скрыть редактор опций" (click)="toggleOptionEditorVisibility(destination)">
        {{ getOptionsAsString(destination, 'опции') }}
      </span>
    </div>
    <div class="form-group destination-options-editor" *ngIf="isVisibleOptionsEditor(destination)">
      <table class="table">
        <tr>
          <td>
            <div class="checkbox">
              <label>
                <input type="checkbox" [(ngModel)]="destination.elevator" name="elevator"> Грузовой лифт
              </label>
            </div>
          </td>
          <td>
            <div class="checkbox">
              <label>
                <input type="checkbox" [(ngModel)]="destination.lifting" name="lifting"> Требуется подъём/спуск
              </label>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="checkbox">
              <label>
                <input type="checkbox" [(ngModel)]="destination.loading" name="loading"> Погрузка
              </label>
            </div>
          </td>
          <td>
            <div class="checkbox">
              <label>
                <input type="checkbox" [(ngModel)]="destination.unloading" name="unloading"> Разгрузка
              </label>
            </div>
          </td>
        </tr>
        <tr *ngIf="draft.delivery">
          <td>
            <div class="checkbox">
              <label>
                <input type="checkbox" [(ngModel)]="destination.unloading_internet_shop_order" name="unloading_order_internet_shop_order">
                Разгрузка заказа из интернет-магазина
              </label>
            </div>
          </td>
          <td *ngIf="i == 0">
            <div class="checkbox">
              <label>
                <input type="checkbox" [(ngModel)]="destination.required_additional_time" name="required_additional_time">
                Требуется дополнительное время на работу с грузом
              </label>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <label for="delivery-to-{{i}}">Место забора/доставки</label>
            <select class="form-control" [(ngModel)]="destination.delivery_to" id="delivery-to-{{i}}" name="deliveryTo{{i}}">
              <option value="">не указано</option>
              <option *ngFor="let v of deliveryVariants|mapToIterable" [value]="v.key">{{ v.val }}</option>
            </select>
          </td>
        </tr>
      </table>

    </div>

    <div class="legal-entity">
      <div class="title">Юридическое лицо</div>
      <div *ngIf="destination.client_legal_entity" class="name">
        <button class="btn btn-xs btn-danger" title="Убрать" (click)="onUnselectLegalEntity(destination)"><span class="glyphicon glyphicon-remove"></span></button>
        {{ destination.client_legal_entity.name }} ({{ destination.client_legal_entity.inn }})
      </div>
      <button class="select-button" (click)="onOpenLegalEntitySelectorFor(destination)">Выбрать</button>
    </div>

    <div class="flex-centered flex-space-between">
      <label>Контактное лицо
        <input class="text-input contact-name" type="text" name="contact_name[{{i}}]" [(ngModel)]="destination.contact_name"></label>
      <label>Контактный телефон
        <input class="text-input" type="text" name="contact_phone[{{i}}]" [(ngModel)]="destination.contact_phone" [attr.placeholder]="destination.is_contacts_hidden && 'телефон скрыт' || ''"></label>
    </div>

    <div class="checkbox sms-action">
      <label>
        <input type="checkbox" class="checkbox" name="contact_send_sms[{{i}}]" [(ngModel)]="destination.contact_send_sms">
        Отправить смс-уведомление контакту
      </label>
    </div>

    <div class="form-group">
      <label>Коментарий</label><Br>
      <textarea class="text-input full-width text-area" name="comment[{{i}}]" [(ngModel)]="destination.comment" rows="2" placeholder="Введите комментарий"></textarea>
    </div>

    <div class="cargo">
      <div class="title">Груз</div>
      <button class="select-button" (click)="onShowDeliveryProductDialog(destination)">Изменить состав ({{ getDeliveryProductsCount(destination) }})</button>
    </div>
  </div>
  <div class="flex-row flex-start">
    <button class="btn btn-default btn-xs glyphicon glyphicon-chevron-up" type="button" *ngIf="i != 0" title="Выше"
            (click)="onUp(i)"></button>
    <button class="btn btn-default btn-xs glyphicon glyphicon-chevron-down" type="button"
            *ngIf="i < destinations.length - 1" title="Ниже" (click)="onDown(i)"></button>
    <button class="btn btn-link btn-xs btn-import" type="button" *ngIf="enabledImport && !visibleImportForms[i]" (click)="onShowImportForm(i)">Импорт из комплексной доставки</button>
    <div *ngIf="enabledImport && visibleImportForms[i]" class="import-form">
      <input type="text" class="text-input" name="complex_delivery[{{i}}]" [(ngModel)]="importForms[i + 1].complexDeliveryId" title="Номер комплексной доставки" placeholder="Комплексная доставка" size="5">
      <input type="text" class="text-input" name="complex_delivery_order[{{i}}]" [(ngModel)]="importForms[i + 1].complexDeliveryOrderId" title="Номер заказа" placeholder="Номер заказа" size="5">
      <label><input type="checkbox" name="import_after[{{i}}]" [(ngModel)]="importForms[i + 1].after"> после</label>
      <button type="button" class="btn btn-xs" title="Импортировать" (click)="onImport(i + 1)"><span class="glyphicon glyphicon-import"></span></button>
    </div>
  </div>
</div>
<div class="flex-row flex-start">
  <button class="save-btn add-btn" type="button" (click)="onAdd()"><i class="material-icons">add</i></button>
  <button class="save-btn reverse-btn" type="button" (click)="onReverse()" title="Отразить маршрут"><img src="/assets/images/reflection.png" alt="отразить маршрут"></button>
  <button class="save-btn optimize-btn" type="button" (click)="onOptimizeRoute()" title="Оптимизировать маршрут"><img src="/assets/images/optimize-route.png" alt="оптимизировать маршрут"></button>
  <button class="save-btn" type="button" (click)="onSave()">Сохранить</button>
</div>
<div class="flex-row flex-start text-danger shake-horizontal form-error" *ngIf="!isValid">
  В данных обнаружены ошибки. Исправьте их до сохранения.
</div>